import styled from 'styled-components';
import { Card, Tabs } from 'antd';
import { COLORS } from '../../constants/colors';

export const PageContainer = styled.div`
  /* No padding here - let PageHeader handle full width */
`;

export const StyledTabs = styled(Tabs)`
  margin: 0 !important;
  background: transparent;
  padding-top: 16px;
  padding-bottom: 8px;
  margin-bottom: 0;
  
  .ant-tabs-nav {
    margin: 0 !important;
    
    &::before {
      display: none !important;
    }
  }
  
  /* Hide ink bar */
  .ant-tabs-ink-bar {
    display: none !important;
  }
  
  /* Make the tab strip horizontally scrollable on small widths */
  .ant-tabs-nav-wrap {
    overflow-x: auto;
    scrollbar-width: none; /* Firefox */
    
    &::-webkit-scrollbar {
      display: none; /* WebKit */
    }
  }
  
  .ant-tabs-nav-list {
    display: flex;
    gap: 4px;
    align-items: center;
    justify-content: flex-start;
    width: auto;
    
    .ant-tabs-tab {
      position: relative;
      padding: 0;
      margin: 0;
      background: transparent;
      border: none;
      transition: all 0.2s ease;
      flex: none;
      width: auto;
      
      /* Remove dividers */
      &::before {
        display: none;
      }
      
      .ant-tabs-tab-btn {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 10px 14px;
        border-radius: 999px;
        color: ${COLORS.textMedium};
        font-weight: 500;
        font-size: 14px;
        transition: background-color .2s ease, color .2s ease;
        background: transparent;
        border: none;
        min-height: 40px;
        white-space: nowrap;
        
        .anticon {
          font-size: 16px;
        }
      }
      
      &:hover .ant-tabs-tab-btn {
        color: ${COLORS.textDark};
        background: rgba(24, 144, 255, 0.08);
      }
      
      &.ant-tabs-tab-active .ant-tabs-tab-btn {
        color: ${COLORS.$primaryBlue};
        background: #eef4ff;
        font-weight: 600;
        box-shadow: 0 1px 3px rgba(0,0,0,.06);
        border: 1px solid rgba(24, 144, 255, 0.3);
      }
      
      /* Visible keyboard focus */
      .ant-tabs-tab-btn:focus-visible {
        outline: 2px solid ${COLORS.$primaryBlue};
        outline-offset: 2px;
        border-radius: 999px;
      }
    }
  }
  
  /* If header-only tabs (no inner tab panels) */
  .ant-tabs-content-holder {
    display: none;
  }
  
  /* Responsive adjustments */
  @media (max-width: 768px) {
    .ant-tabs-nav-list {
      gap: 2px;
      
      .ant-tabs-tab {
        .ant-tabs-tab-btn {
          font-size: 13px;
          padding: 8px 12px;
          min-height: 36px;
          
          .anticon {
            font-size: 14px;
          }
        }
      }
    }
  }
  
  @media (max-width: 576px) {
    .ant-tabs-nav-list {
      .ant-tabs-tab {
        .ant-tabs-tab-btn {
          font-size: 12px;
          padding: 6px 8px;
          min-height: 32px;
          gap: 4px;
          
          .anticon {
            font-size: 12px;
          }
        }
      }
    }
  }
`;

export const TabsBorderDiv = styled.div`
  border-bottom: 1px solid ${COLORS.border};
  margin-bottom: 20px;
`;

export const TabContent = styled.div`
  padding-top: 4px;
  max-width: 1200px;
  margin: 0 auto;
`;

export const SettingsCard = styled(Card)`
  height: 100%;
  border-radius: 12px;
  border: 1px solid ${COLORS.border};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  
  .ant-card-body {
    padding: 24px;
  }
  
  @media (max-width: 768px) {
    .ant-card-body {
      padding: 16px;
    }
  }
`;

export const SectionTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 18px;
  font-weight: 600;
  color: ${COLORS.textDark};
  margin-bottom: 24px;
  padding-bottom: 12px;
  border-bottom: 1px solid ${COLORS.border};
`;

export const ProfileSection = styled.div`
  .ant-form-item-label > label {
    font-weight: 500;
    color: ${COLORS.textDark};
  }
  
  .ant-input,
  .ant-input-password .ant-input {
    height: 48px;
    font-size: 16px;
  }
  
  .ant-select .ant-select-selector {
    height: 48px;
    
    .ant-select-selection-item {
      line-height: 46px;
    }
  }
  
  .ant-input:disabled {
    background-color: ${COLORS.backgroundLight};
    color: ${COLORS.textMedium};
  }
  
  .ant-select.ant-select-disabled .ant-select-selector {
    background-color: ${COLORS.backgroundLight};
    color: ${COLORS.textMedium};
  }
`;

export const SettingsSection = styled.div`
  .ant-form-item {
    margin-bottom: 0;
  }
  
  .ant-form-item-label > label {
    font-weight: 500;
    color: ${COLORS.textDark};
  }
  
  .ant-input,
  .ant-input-password .ant-input {
    height: 48px;
    font-size: 16px;
  }
  
  .ant-switch {
    background-color: #d9d9d9;
    
    &.ant-switch-checked {
      background-color: ${COLORS.$primaryBlue};
    }
  }
  
  .ant-divider {
    border-color: ${COLORS.border};
  }
`;

export const SecuritySection = styled.div`
  .ant-form-item {
    margin-bottom: 24px;
  }
  
  .ant-form-item-label > label {
    font-weight: 500;
    color: ${COLORS.textDark};
  }
  
  .ant-input,
  .ant-input-password .ant-input {
    height: 48px;
    font-size: 16px;
  }
  
  .security-info-box {
    padding: 20px;
    background-color: #f8f9fa;
    border-radius: 8px;
    border: 1px solid ${COLORS.border};
    
    ul {
      margin-top: 8px;
      margin-bottom: 0;
      padding-left: 20px;
      
      li {
        margin-bottom: 4px;
        color: ${COLORS.textMedium};
        font-size: 14px;
      }
    }
    
    .ant-typography {
      margin-bottom: 8px;
      color: ${COLORS.textDark};
      font-weight: 500;
    }
  }
`;

export const QuickLinksSection = styled.div`
  .quick-links-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 16px;
    margin-top: 16px;
  }
  
  .quick-link-item {
    padding: 20px;
    border: 1px solid ${COLORS.border};
    border-radius: 8px;
    background: white;
    transition: all 0.3s ease;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 16px;
    
    &:hover {
      border-color: ${COLORS.$primaryBlue};
      box-shadow: 0 2px 8px rgba(24, 144, 255, 0.15);
      transform: translateY(-1px);
    }
    
    .link-icon {
      width: 48px;
      height: 48px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      color: white;
      flex-shrink: 0;
    }
    
    .link-content {
      flex: 1;
      
      .link-title {
        font-size: 16px;
        font-weight: 600;
        color: ${COLORS.textDark};
        margin-bottom: 4px;
        line-height: 1.2;
      }
      
      .link-description {
        font-size: 14px;
        color: ${COLORS.textMedium};
        line-height: 1.4;
      }
    }
    
    .link-arrow {
      color: ${COLORS.textMedium};
      font-size: 16px;
      opacity: 0.6;
      transition: all 0.3s ease;
    }
    
    &:hover .link-arrow {
      opacity: 1;
      transform: translateX(2px);
    }
  }
  
  @media (max-width: 768px) {
    .quick-links-grid {
      grid-template-columns: 1fr;
      gap: 12px;
    }
    
    .quick-link-item {
      padding: 16px;
      
      .link-icon {
        width: 40px;
        height: 40px;
        font-size: 18px;
      }
      
      .link-content {
        .link-title {
          font-size: 15px;
        }
        
        .link-description {
          font-size: 13px;
        }
      }
    }
  }
`;
